import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=534cc77f&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.css?vue&type=style&index=0&id=534cc77f&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534cc77f",
  null
  
)

export default component.exports